import { Outlet } from "react-router-dom";
import { AuthenticationBoundary } from "@/auth/authentication-boundary";
import { NotificationProvider } from "@/features/notifications/notification-provider";
import { TopbarIslandProvider } from "@/features/workbench/topbar-island-context";

/**
 * 独立工作台分支的根。
 *
 * 从旧组合根的 `RootLayout` 下移到这里（嵌入设计 §5.2）：
 * 这两个 Provider 原本挂在 router 根上、无条件包住整张路由表，
 * `/embedded` 会跟着继承它们——`AuthenticationBoundary` 会在 iframe 里跳 IAM 登录，
 * `NotificationProvider` 会拿着空 Token 陷入 SignalR 401 重连循环（AR-25）。
 *
 * 两条既有约束在这里保持不变：
 * - 必须在 `RouterProvider` 之内——认证边界要用 `useLocation` 记住登录前的位置。
 * - 必须盖住 `standaloneRoutes` 里的 `*` 兜底路由，否则 OIDC 回调地址会先被兜底路由重定向掉。
 */
export function StandaloneRoot() {
  return (
    <AuthenticationBoundary>
      <TopbarIslandProvider>
        <NotificationProvider>
          <Outlet />
        </NotificationProvider>
      </TopbarIslandProvider>
    </AuthenticationBoundary>
  );
}
